import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { CardType } from '../../../common/spdCore/validation/schemas';

export const navigateToCardByType = (
  nav: ReturnType<typeof useNavigation>,
  cardType: CardType | string | null | undefined,
  examId: string,
  newWindow?: boolean,
) => {
  switch (cardType as CardType) {
    case CardType.Psychologist:
      void nav.examCardsPsychologic(examId, newWindow);
      break;
    case CardType.PsychologistWeapon:
      void nav.examCardsPsychologicWeapon(examId, newWindow);
      break;
    case CardType.Weapon:
      void nav.examCardsWeapon(examId, newWindow);
      break;
    case CardType.Preventive:
      void nav.examCardsPreventive(examId, newWindow);
      break;
    case CardType.Driver:
      void nav.examCardsDriver(examId, newWindow);
      break;
    case CardType.Sanitary:
      void nav.examCardsSanitary(examId, newWindow);
      break;
    case CardType.Sport:
      void nav.examCardsSport(examId, newWindow);
      break;
  }
};

export const CardsLink: React.FC<{
  examId: string;
  type: CardType;
  newWindow?: boolean;
}> = props => {
  const nav = useNavigation();

  return (
    <OverlayTrigger overlay={<Tooltip>Edycja karty do badania</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          navigateToCardByType(nav, props.type, props.examId, props.newWindow);
        }}
        variant="btn-info"
      >
        {props.newWindow ? <Icon.BoxArrowUpRight /> : <Icon.CardText />}
      </Button>
    </OverlayTrigger>
  );
};
